import { Get, Post } from "../fetch";
import { urls } from "../constants";
export async function getTenantConfiguration(tenantId) {
  return Get(`${urls.subscriptions.billing.tenantConfiguration.v1}/${tenantId}`);
}
export async function createTenantConfiguration(request) {
  return Post(`${urls.subscriptions.billing.tenantConfiguration.v1}`, request);
}